<style lang="stylus" scoped>
    .edit-theme-container
        .theme-preview
            .img-wrapper
                width 100%
                border 1px solid var(--color-black-8)
                display flex
                justify-content center
                align-items center
                border-radius 8px
                padding 16px 0
                img
                    width 83px
            .title-section
                display flex
                justify-content center
                align-items center
                margin auto
                width min-content
                margin-top 12px
                padding-left 24px
                >span
                    width 24px
                    height 24px
                    cursor pointer
                svg
                    display none
                &:hover
                    svg
                        display block
                        width 24px
                        height 24px
            .theme-title
                text-align center
                max-width 230px
                .edit-input
                    color var(--text-color-primary)
                    &::selection
                        background var(--theme-color-16)
                        color var(--text-color-primary)

                .input-tips
                    min-width 100px
        .form-list
            margin-top 10px
            margin-bottom 67px
            .form-item
                margin-bottom 24px
                .form-title
                    margin-bottom 12px
                    font-size 12px
                    font-weight 700
                    color var(--text-color-primary)
                .flex-form-item
                    display flex
                    justify-content space-between
                    align-items center
                    .color-select
                        width 104px
                        font-size 12px
                        position relative
                        .showBox
                            span
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                        .choosed-color
                            width 60px
                            height 18px
                            box-shadow 0 1px 6px var(--color-black-2)
                        .color-box
                            position absolute
                            right -10px
                            top 32px
                            background-color var(--bg-color-ivu-select-dropdown)
                            box-shadow $box-shadow
                            width 241px
                            border-radius 8px
                            .top-bar
                                padding 12px 16px
                                display flex
                                justify-content space-between
                                align-items center
                            /deep/.palette.force-windowtype
                                box-shadow none !important
                                border-top 1px solid var(--color-black-8)
                                border-top-left-radius 0
                                border-top-right-radius 0

                .selectbox
                    width 80px
                    border 1px solid var(--color-black-8)
                    border-radius 4px
                    padding 2px 6px
                    position relative
                    .showBox
                        display flex
                        justify-content space-between
                        align-items center
                    .item-icon
                        width 60px
                        height 18px
                        padding-right 8px
                    .linebox-selector
                        display block
                        position absolute
                        left 0
                        bottom 30px
                        width 100%
                        list-style none
                        background-color var(--bg-color-ivu-select-dropdown)
                        box-shadow $box-shadow
                        z-index 1
                        max-height 150px
                        overflow-y scroll
                        overflow-x hidden
                        padding 6px
                        border-radius 8px;
                        > li
                            height 24px
                            border-radius 6px
                            padding 5px 0;
                            position relative
                            .rotate
                                transform translate(-50%, -50%) rotate(180deg) !important
                            .item-icon
                                position absolute
                                top 50%
                                left 50%
                                transform translate(-50%, -50%)
                                width 60px
                                height 18px
                            .item-linestyle
                                width 50px !important
                                margin 0 auto;
                                padding-right 0
                            &:hover
                                background-color var(--bg-color-ivu-select-dropdown-select-item)
            .text-form
                .text-form-item
                    margin-bottom 16px
                    &:last-child
                        margin-bottom 0
                    .size-select
                        width 104px
                    .other-set
                        display flex
                        justify-content space-between
                        align-items center
                        gap 12px
                        .font-btn
                            width 28px
                            height 28px
                            cursor pointer
                            border-radius 6px
                            svg
                                width 24px
                                height 24px
                                margin auto
                            &:hover
                                background-color $main-hovercolor
                            &.activeFunc
                                background-color #a7d0fb
                            &.font-btn-active
                                background-color $main-selectcolor



            .color-form
                .color-list
                    width 100%
                    height 20px
                    display flex
                    align-items center
                    justify-content space-between
                    gap 7px
                    .color-item
                        width 22px
                        height 22px
                        border-radius 50%
                        border 2px solid var(--color-white)
                        cursor pointer
                        &.active,
                        &:hover
                            outline 2px solid var(--themeColor)
            .connector-form
                .connector-form-item
                    margin-bottom 16px
                    &:last-child
                        margin-bottom 0
                    .ivu-select
                        .ivu-select-selection
                            border 0
                        .ivu-select-selected-value
                            padding-left 0
                        .ivu-select-arrow
                            right 0
                    .color-box
                        bottom 32px
                        top unset !important
                .line-arrow-item
                    justify-content space-between
                    align-items center
                    .line-switch
                        width 24px
                        height 24px
                        cursor pointer
                        display flex
                        align-items center
                        justify-content center
                        svg
                            width 16px
                            height 16px
                            color var(--svg-color-primary)


                    .item-dropbox
                        position relative
                        width 90px
                        border-radius 4px

                        &.line-begin, &.line-end

                            .item-preview
                                pointer-events unset
                                position relative
                                .arrow-type
                                    position absolute
                                    top -12px
                                    height 40px
                                    width  50px

                                .ios-arrow
                                    width 12px
                                    height 12px
                                    position absolute
                                    pointer-events none
                                    top 50%
                                    right 6px
                                    color var(--svg-color-primary)
                                    transform translateY(-50%)


                            .item-downs
                                padding 16px 0 10px 16px
                                height 360px
                                width 216px !important
                                overflow hidden
                                border none
                                border-radius 8px
                                box-shadow var(--box-shadow-color-box)
                                .line-title
                                    line-height 16px
                                    margin-bottom 12px
                                    text-indent 0

                                .line-size
                                    padding-right 16px
                                    .ivu-slider
                                        .ivu-slider-wrap
                                            margin-left auto
                                            width 100%
                                            .ivu-slider-stop
                                                // background-color #424242




                                .line
                                    margin 16px 16px 16px 0
                                    border-top 1px solid var(--border-color-box-8)

                                .line-type-wrapper
                                    height calc(100% - 74px)
                                    overflow-y auto
                                    display block
                                    padding-right 16px
                                    .line-type-content
                                        display grid
                                        grid-template-columns repeat(4, 1fr)
                                        grid-gap 8px

                                    .item-down
                                        width 40px
                                        height 40px
                                        border-radius 6px
                                        position relative
                                        &:hover, &.active
                                            background-color transparent

                                        &.active
                                            .border
                                                border 2px solid var(--themeColor)


                                        &:hover
                                            .border
                                                border-color var(--themeColor)

                                        .arrowtype
                                            width 34px
                                            height 40px
                                            position absolute
                                            top 0
                                            left 5px
                                            color var(--svg-color-gray-42)

                                        .border
                                            width 40px
                                            height 40px
                                            position absolute
                                            top 0
                                            left 0
                                            border-radius 6px
                                            border 1px solid var(--border-color-box-8)

                        &.line-begin
                            .item-preview .arrow-type
                                left -1px

                            .item-downs
                                right: auto
                                .line-type-wrapper .item-down .arrowtype
                                    left 0
                        &.line-end
                            .item-downs
                                .line-type-wrapper .item-down .arrowtype
                                    left 0

        .save-bar
            position absolute
            z-index 2
            bottom 0
            left 0
            height 56px
            border-top 1px solid var(--color-black-8)
            padding 12px 16px
            display flex
            align-items center
            // background var(--color-white)
            width 100%
            .save-btn
                width 100%
                height 32px
                line-height 32px
                background var(--themeColor)
                border-radius 6px
                color #fff
                font-size 12px
                text-align center
                cursor pointer
                &:hover
                    background var(--themeHover)
    /deep/.ivu-select.ivu-select-single
        .ivu-select-selection
            height 24px
            .ivu-select-selected-value
                height 24px
                line-height 24px
    /deep/.ivu-input-number
        height 24px
        line-height 24px
        .ivu-input-number-input-wrap
            height 24px
            .ivu-input-number-input
                height 24px
                line-height 24px
    /deep/.palette-content
        margin-top 8px !important
    /deep/.ivu-select-arrow
        color var(--svg-color-primary) !important
</style>

<template>
    <EditBox
        :setTitle="themeIsCustom || !theme || (theme && theme.themeID === 0) ? $t('editCustomTitle') : $t('editBoxTitle')"
        class="edit-theme-container"
    >
        <div class="theme-preview">
            <div class="img-wrapper" :style="{ background: bkgColor }">
                <img :src="themeImg" draggable="false" />
            </div>
            <div class="title-section">
                <ClickEdit class="theme-title" :text="themeName" :eventName="'click'" @editOK="rename" />
                <span class="edit-name-icon">
                    <iconSymbol name="theme-edit"></iconSymbol>
                </span>
            </div>
        </div>
        <div class="form-list">
            <div class="form-item text-form">
                <div class="form-title">{{ $t("text") }}</div>
                <div class="text-form-item">
                    <i-select v-model="fontFamily" @on-change="changeCurrentThemeText">
                        <i-option v-for="(item, i) in familyList" :value="item" :label="item" :key="i">{{ item }}</i-option>
                    </i-select>
                </div>
                <div class="text-form-item flex-form-item">
                    <i-select v-model="fontSize" class="size-select" @on-change="changeCurrentThemeText">
                        <i-option v-for="(item, i) in sizeList" :value="item" :label="item" :key="i">{{ item }}</i-option>
                    </i-select>
                    <div class="other-set">
                        <div
                            class="font-btn"
                            :class="{ 'font-btn-active': fontBold }"
                            :content="$t('bold')"
                            v-tippy="{ placement: 'bottom' }"
                            @click.stop="clickBtn('bold')"
                        >
                            <iconSymbol class="item-icon-center" :name="'bold'"></iconSymbol>
                        </div>
                        <div
                            class="font-btn"
                            :class="{ 'font-btn-active': fontItalic }"
                            :content="$t('italy')"
                            v-tippy="{ placement: 'bottom' }"
                            @click.stop="clickBtn('italic')"
                        >
                            <iconSymbol class="item-icon-center" :name="'italy'"></iconSymbol>
                        </div>
                        <div
                            class="font-btn"
                            :class="{ 'font-btn-active': fontUnderline }"
                            :content="$t('underline')"
                            v-tippy="{ placement: 'bottom' }"
                            @click.stop="clickBtn('underline')"
                        >
                            <iconSymbol class="item-icon-center" :name="'underline'"></iconSymbol>
                        </div>
                    </div>
                </div>
                <!-- <div class="text-form-item flex-form-item">
                    <span class="label">{{ $t("textColor") }}</span>
                    <div class="selectbox color-select" v-click-outside="() => (showTextColor = false)">
                        <div class="showBox" @click.stop="showTextColor = !showTextColor">
                            <template>
                                <span v-if="textFlowThemeColor">{{ $t("followThemeColor") }}</span>
                                <div v-else class="choosed-color" :style="{ backgroundColor: fontColor }"></div>
                            </template>
                            <Icon type="ios-arrow-down" />
                        </div>
                        <div class="color-box" v-show="showTextColor">
                            <div class="top-bar">
                                <span class="label">{{ $t("followThemeColor") }}</span>
                                <i-switch size="small" v-model="textFlowThemeColor" @on-change="changeTextFlowThemeColor" />
                            </div>
                            <div @click="showTextColor = false" v-if="!textFlowThemeColor">
                                <Palette :force="true" :windowType="'themeTextColor'" :useMask="false" />
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="form-item color-form">
                <div class="form-title">{{ $t("colors") }}</div>
                <div class="color-list">
                    <template v-for="(color, i) in colorList">
                        <div
                            class="color-item"
                            :class="{ active: currentColorIndex === i }"
                            :key="i"
                            :style="{ backgroundColor: color }"
                            v-if="i < 8"
                            @click="showMoreColor($event, i, color)"
                        ></div>
                    </template>
                </div>
            </div>
            <div class="form-item connector-form">
                <div class="form-title">{{ $t("line") }}</div>
                <div class="rPanel-item line-arrow-item">
                    <div class="item-dropbox border-hover line-begin" v-click-outside="closeBeginTypes">
                        <div class="item-preview" @click="toggleType($event, 'Begin')" v-tippy="{ content: $t('beginType'), placement: 'top' }">
                            <iconSymbol class="full full-preview arrow-type" :name="activeBeginTypeUrl(arrowStyleBegin)" />
                            <Icon class="ios-arrow" type="ios-arrow-down" />
                        </div>
                        <div class="item-downs" ref="BeginRef" v-show="showBeginType">
                            <div class="line-title">{{ $t("arrowSize") }}</div>
                            <div class="line-size">
                                <LineSlider
                                    ref="BeginSlider"
                                    v-model="arrowSizeBegin"
                                    :step="1"
                                    :max="7"
                                    :min="1"
                                    @on-change="changeCurrentThemeConnector"
                                ></LineSlider>
                            </div>
                            <div class="line"></div>
                            <ScrollView class="line-type-wrapper">
                                <div class="line-type-content">
                                    <div
                                        class="item-down begindown"
                                        v-for="item in 50"
                                        :class="{ active: arrowStyleBegin + 1 == item }"
                                        :key="item"
                                        @click.stop="clickSelector('beginStyle', item - 1)"
                                    >
                                        <iconSymbol class="full arrowtype" :name="activeBeginTypeUrl(item - 1)" />
                                        <div class="border"></div>
                                    </div>
                                </div>
                            </ScrollView>
                        </div>
                    </div>
                    <div class="line-switch" @click="switchArrow">
                        <iconSymbol name="connector-switch" draggable="false" @dragstart.native.prevent />
                    </div>
                    <div class="item-dropbox border-hover line-end" v-click-outside="closeEndTypes">
                        <div class="item-preview" @click="toggleType($event, 'End')" v-tippy="{ content: $t('endType'), placement: 'top' }">
                            <iconSymbol class="full rotate full-preview arrow-type" :name="activeEndTypeUrl(arrowStyleEnd)" />
                            <Icon class="ios-arrow" type="ios-arrow-down" />
                        </div>
                        <div class="item-downs" ref="EndRef" v-show="showEndType">
                            <div class="line-title">{{ $t("arrowSize") }}</div>
                            <div class="line-size">
                                <LineSlider
                                    ref="EndSlider"
                                    v-model="arrowSizeEnd"
                                    :step="1"
                                    :max="7"
                                    :min="1"
                                    @on-change="changeCurrentThemeConnector"
                                ></LineSlider>
                            </div>
                            <div class="line"></div>
                            <ScrollView class="line-type-wrapper">
                                <div class="line-type-content">
                                    <div
                                        class="item-down enddown"
                                        v-for="item in 50"
                                        :class="{ active: arrowStyleEnd + 1 == item }"
                                        :key="item"
                                        @click.stop="clickSelector('endStyle', item - 1)"
                                    >
                                        <iconSymbol class="full rotate arrowtype" :name="activeEndTypeUrl(item - 1)" />
                                        <div class="border"></div>
                                    </div>
                                </div>
                            </ScrollView>
                        </div>
                    </div>
                </div>
                <div class="connector-form-item flex-form-item">
                    <span class="label">{{ $t("thickness") }}</span>
                    <InputNumber
                        :active-change="false"
                        :formatter="(value) => `${value ? value.toFixed(2) : 0} pt`"
                        :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                        :max="200"
                        :min="0.25"
                        :step="0.25"
                        v-model="strokeWidth"
                        class="themeline-number"
                        style="width: 80px"
                        @on-change="changeCurrentThemeConnector"
                    />
                </div>
                <div class="connector-form-item flex-form-item">
                    <span class="label">{{ $t("cornerRadius") }}</span>
                    <InputNumber
                        :active-change="false"
                        :formatter="(value) => `${value} mm`"
                        :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                        :max="9999"
                        :min="0"
                        :step="1"
                        v-model="round"
                        class="themeline-number"
                        style="width: 80px"
                        @on-change="changeCurrentThemeConnector"
                    />
                </div>

                <div class="connector-form-item flex-form-item">
                    <span class="label">{{ $t("lineStyle") }}</span>
                    <div class="selectbox" v-click-outside="() => (showListType = '')">
                        <div class="showBox" @click.stop="showSelector('strokeStyle')">
                            <iconSymbol class="item-icon" :name="activeDashTypeUrl(strokeStyle - 1)" />
                            <Icon type="ios-arrow-down" />
                        </div>
                        <ul class="linebox-selector" v-show="showListType == 'strokeStyle'">
                            <li v-for="item in 23" :key="item" @click.stop="clickSelector('strokeStyle', item)">
                                <iconSymbol class="item-icon item-linestyle" :name="activeDashTypeUrl(item - 1)" />
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="connector-form-item flex-form-item">
                    <span class="label">{{ $t("lineColor") }}</span>
                    <div class="selectbox color-select" v-click-outside="() => (showConnectorColor = false)">
                        <div class="showBox" @click.stop="showConnectorColor = !showConnectorColor">
                            <template>
                                <span v-if="connectorFlowThemeColor">{{ $t("followThemeColor") }}</span>
                                <div v-else class="choosed-color" :style="{ backgroundColor: connectorColor }"></div>
                            </template>
                            <Icon type="ios-arrow-down" />
                        </div>
                        <div class="color-box" v-show="showConnectorColor">
                            <div class="top-bar">
                                <span class="label">{{ $t("followThemeColor") }}</span>
                                <i-switch size="small" v-model="connectorFlowThemeColor" @on-change="changeLineFlowThemeColor" />
                            </div>
                            <div @click="showConnectorColor = false" v-if="!connectorFlowThemeColor">
                                <Palette :force="true" :windowType="'themeConnectorColor'" :useMask="false" />
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="save-bar">
            <div class="save-btn" @click="saveCurrentTheme">
                {{ themeIsCustom ? $t("save") : $t("saveAsMyTheme") }}
            </div>
        </div>
    </EditBox>
</template>

<script lang="ts">
    import { Component, Vue, Inject } from "vue-property-decorator";
    import EditBox from "./BaseSet.vue";
    import ClickEdit from "@/app/components/Common/ClickEdit.vue";
    import cloneDeep from "lodash/cloneDeep";
    import Palette from "@/app/components/Common/Color/Palette.vue";
    import LineSlider from "../LineSlider.vue";
    import ScrollView from "@/public/components/ScrollView/ScrollView.vue";

    @Component({
        components: {
            EditBox,
            ClickEdit,
            Palette,
            LineSlider,
            ScrollView,
        },
    })
    export default class Theme extends Vue {
        @Inject()
        ["showMessage"];

        fontFamily: string = "宋体";
        familyList: Array<string> = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "sans-serif",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
            "仿宋",
            "楷体",
            "隶书",
            "微软雅黑",
            "黑体",
            "宋体",
            "华文楷体",
            "华文行楷",
            "华文新魏",
        ];
        enFamily: string[] = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
        ];
        zhFamily: string[] = ["仿宋", "楷书", "隶书", "微软雅黑", "黑体", "宋体", "华文楷体", "华文行楷", "华文新魏"];

        fontSize: number = 10;
        sizeList: Array<number> = [6, 7, 8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];

        get customSet() {
            return this.$store.state.ui.defaultFontType == 1;
        }
        get ignoreDefFont() {
            return this.$store.state.page.ignoreDefFont;
        }

        get colorTheme() {
            return this.$store.getters.colorTheme;
        }

        get themeImg() {
            return this.$store.state.page.activeThemeImage;
        }

        get theme() {
            return this.$store.getters.theme || this.$store.state.page.theme;
        }

        get themes() {
            return this.$store.getters.themes._themes;
        }

        bkgColor = "#fff";
        themeIsCustom = false;
        oldThemeName = "";
        oldTheme: any = {};
        initCurTheme() {
            this.themeIsCustom = this.theme.isCustom && this.theme.isCustom();
            this.oldThemeName = this.theme.localName ? this.theme.localName(this.lang) : "";
            this.oldTheme.textTheme = cloneDeep(this.textTheme);
            this.oldTheme.connectorTheme = cloneDeep(this.connectorTheme);
            this.oldTheme.colorTheme = JSON.parse(JSON.stringify(this.colorTheme));
            this.oldTheme.theme = JSON.parse(JSON.stringify(this.theme));
            this.themeName = this.themeIsCustom ? this.theme.localName(this.lang) : this.formatName(this.themes, this.$t("myTheme"));

            let view = window["_view"];
            if (!view) return;
            let curBkg = view._activePage.getCurPageBkgndColor();
            this.bkgColor = curBkg;
        }

        buildRegex(themeName) {
            function escapeRegExp(string) {
                return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& 表示整个匹配的字符串
            }

            // 构建正则表达式，使用非捕获组和可选的数字括号
            const regexString = `^${escapeRegExp(themeName)}(?:\\(\\d+\\))?$`;
            const regex = new RegExp(regexString);

            return regex;
        }

        themeName: any = "";

        rename(newName: string) {
            this.themeName = newName;
        }

        strokeWidth: number = 0.75;
        round: number = 0;
        strokeStyle: number = 1;
        arrowStyleBegin: number = 0;
        arrowStyleEnd: number = 0;
        arrowSizeBegin: number = 4;
        arrowSizeEnd: number = 4;
        arrowSizeList: Array<Object> = [
            {
                id: 2,
                text: "Very Small",
            },
            {
                id: 3,
                text: "Small",
            },
            {
                id: 4,
                text: "Middle",
            },
            {
                id: 6,
                text: "Large",
            },
            {
                id: 9,
                text: "Extra Large",
            },
            {
                id: 12,
                text: "Jumbo",
            },
            {
                id: 14,
                text: "Colossal",
            },
        ];

        activeDashTypeUrl(index) {
            return "dt" + index;
        }

        activeBeginTypeUrl(index) {
            return "arrow-" + index;
        }

        activeEndTypeUrl(index) {
            return "arrow-" + index;
        }

        showListType: string = "";
        showSelector(type: string) {
            this.showListType = type;
        }

        saveCurrentTheme() {
            this.changeCurrentTheme(!this.themeIsCustom ? "saveAs" : "save");
        }

        change() {}

        clickBtn(type: string) {
            let _type = `font${type.charAt(0).toUpperCase() + type.slice(1)}`;
            this[_type] = !this[_type];
            this.changeCurrentThemeText();
        }

        switch1 = "";

        get textTheme() {
            return this.$store.getters.textTheme;
        }

        parseQueryString(queryString) {
            const pairs = queryString.split("&");
            return pairs.reduce((acc, pair) => {
                const [key, value] = pair.split("=");
                acc[key] = value;
                return acc;
            }, {});
        }

        fontBold = false;
        fontItalic = false;
        fontUnderline = false;

        initText(textTheme) {
            let textInfo = this.parseQueryString(textTheme.getTextEditInfo());
            const { _font, _textFontSize, _bold, _italic, _underline, _color } = textInfo;
            this.fontFamily = _font;
            this.fontSize = Number(_textFontSize);
            this.fontBold = _bold === "true";
            this.fontItalic = _italic === "true";
            this.fontUnderline = _underline === "true";
            this.fontColor = _color;
        }

        changeCurrentThemeText() {
            const recommendText = this.textThemes.filter((item) => !item.isCustom());
            let recoomendTextIds = recommendText.map((item) => item._id);
            if (recoomendTextIds.indexOf(this.textTheme._id) > -1) {
                this.changeCurrentTheme("createText");
            } else {
                this.changeCurrentTheme("editText");
            }
        }

        get textThemes() {
            return this.$store.getters.textThemes._themeText;
        }

        changeThemeTextColor(color) {
            this.fontColor = color;
            const recommendEffect = this.effectThemes.filter((item) => !item.isCustom());
            let recoomendEffectIds = recommendEffect.map((item) => item._id);
            if (recoomendEffectIds.indexOf(this.effectTheme._id) > -1) {
                this.changeCurrentTheme("createEffect");
            } else {
                this.changeCurrentTheme("editEffect");
            }
        }

        themeTextName: string = "";
        themeConnectorName: string = "";
        themeColorName: string = "";
        themeEffectName: string = "";
        changeCurrentTheme(type) {
            let view = window["_view"];
            if (!view) return;
            let msgExist = this.$t("existTheme");
            let flag: boolean;
            let currentThemeId = this.theme._id || this.theme.themeID;
            if (type === "saveAs") {
                let payload = {
                    clrThemeID: this.theme._clrThemeID || this.theme.clrThemeID,
                    cntThemeID: this.theme._cntThemeID || this.theme.cntThemeID,
                    effThemeID: this.theme._effThemeID || this.theme.effThemeID,
                    textThemeID: this.theme._textThemeID || this.theme.textThemeID,
                };
                flag = view.createTheme(this.themeName, payload, currentThemeId, this.oldTheme.theme._id);
            } else if (type === "save") {
                if (this.themeName === this.oldThemeName) {
                    flag = true;
                } else {
                    flag = view.renameTheme(currentThemeId, this.themeName);
                }
            } else if (type === "createText") {
                let payload: any = {
                    font: this.fontFamily,
                    size: this.fontSize,
                    _bold: this.fontBold,
                    _italic: this.fontItalic,
                    _underline: this.fontUnderline,
                };
                // if(!this.textFlowThemeColor){
                //     payload._color = this.fontColor;
                //     payload.effectId = this.effectTheme._id
                // }
                this.themeTextName = this.formatName(this.textThemes, this.$t("myText"));
                flag = view.createThemeFonts(this.themeTextName, payload);
            } else if (type === "editText") {
                let payload: any = {
                    font: this.fontFamily,
                    size: this.fontSize,
                    _bold: this.fontBold,
                    _italic: this.fontItalic,
                    _underline: this.fontUnderline,
                };
                // if(!this.textFlowThemeColor){
                //     payload._color = this.fontColor;
                //     payload.effectId = this.effectTheme._id
                // }
                const textName = this.textTheme.localName(this.lang);
                flag = view.editThemeFonts(textName, payload, this.textTheme._id);
            } else if (type === "createConnector") {
                let payload: any = {
                    width: this.strokeWidth,
                    round: this.round,
                    dash: this.strokeStyle,
                    arrowStyleBegin: this.arrowStyleBegin,
                    arrowStyleEnd: this.arrowStyleEnd,
                    arrowSizeBegin: this.arrowSizeBegin,
                    arrowSizeEnd: this.arrowSizeEnd,
                    flowThemeColor: this.connectorFlowThemeColor,
                };
                payload.color = !this.connectorFlowThemeColor ? this.connectorColor : this.oldConnectorColor;
                this.themeConnectorName = this.formatName(this.connectorThemes, this.$t("myStyle"));
                flag = view.createLineTheme(this.themeConnectorName, payload);
            } else if (type === "editConnector") {
                let payload: any = {
                    width: this.strokeWidth,
                    round: this.round,
                    dash: this.strokeStyle,
                    arrowStyleBegin: this.arrowStyleBegin,
                    arrowStyleEnd: this.arrowStyleEnd,
                    arrowSizeBegin: this.arrowSizeBegin,
                    arrowSizeEnd: this.arrowSizeEnd,
                    flowThemeColor: this.connectorFlowThemeColor,
                };
                payload.color = !this.connectorFlowThemeColor ? this.connectorColor : this.oldConnectorColor;
                const connectorName = this.connectorTheme.localName(this.lang);
                flag = view.editLineTheme(connectorName, payload, this.connectorTheme._id);
            } else if (type === "createColorList") {
                let fromId = this.checkLimitColor() ? (this.theme ? this.theme.clrThemeID || this.theme._clrThemeID : this.colorTheme._id) : -1;
                this.themeColorName = this.formatName(this.colorThemes, this.$t("myColor"));
                flag = view.createThemeColor(this.themeColorName, this.colorList.slice(), fromId);
            } else if (type === "editColorList") {
                let payload = {
                    _clrs: this.colorList.slice(),
                };
                const colorName = this.colorTheme.localName(this.lang);
                flag = view.editThemeColor(colorName, payload, this.colorTheme._id);
            } else if (type === "createEffect") {
                let payload: any = {
                    _color: this.fontColor,
                    _oldEffectId: this.oldEffectId,
                };
                this.themeEffectName = this.formatName(this.effectThemes, this.$t("myEffect"));
                flag = view.createThemeEffect(this.themeEffectName, payload);
            } else if (type === "editEffect") {
                let payload = {
                    _color: this.fontColor,
                };
                const effectName = this.effectTheme.localName(this.lang);
                flag = view.editThemeEffect(effectName, payload, this.effectTheme._id);
            }
            if (flag) {
                if (type === "saveAs" || type === "save") {
                    let changeTheme = this.themes.find((item) => item.localName(this.lang) === this.themeName);
                    let changeThemeId = changeTheme._id;
                    if (type == "save") {
                        const changePayload = {
                            clrThemeID: this.theme.clrThemeID || this.theme._clrThemeID,
                            cntThemeID: this.theme.cntThemeID || this.theme._cntThemeID,
                            effThemeID: this.theme.effThemeID || this.theme._effThemeID,
                            textThemeID: this.theme.textThemeID || this.theme._textThemeID,
                            name: this.themeName,
                        };
                        view.editTheme(changeThemeId, changePayload);
                    }
                    view.changeTheme(changeThemeId, false);
                    this.themeIsCustom = changeTheme.isCustom();
                    this.oldThemeName = this.themeName;
                    this.oldTheme = {
                        textTheme: cloneDeep(this.textTheme),
                        connectorTheme: cloneDeep(this.connectorTheme),
                        colorTheme: JSON.parse(JSON.stringify(this.colorTheme)),
                        theme: JSON.parse(JSON.stringify(this.theme)),
                    };
                    this.$bus.$emit(
                        "setRightViewTitle",
                        this.themeIsCustom || !this.theme || (this.theme && this.theme.themeID === 0) ? "editCustomTitle" : "editTheme"
                    );
                    this.$edMessage.success(this.$t("saveSuccess"));
                    this.sensors.track("saveTheme", {
                        Catalogues: "rightMenu Bar",
                        theme_type: type === "save" ? "save" : "saveAsNew",
                    });
                } else if (type === "createText") {
                    const textId = this.textThemes.find((item) => item.localName(this.lang) === this.themeTextName)._id;
                    view.changeThemeText(textId);
                } else if (type === "editText") {
                    view.changeThemeText(this.textTheme._id);
                } else if (type === "createConnector") {
                    const connectorId = this.connectorThemes.find((item) => item.localName(this.lang) === this.themeConnectorName)._id;
                    view.changeThemeConnector(connectorId, false);
                } else if (type === "editConnector") {
                    view.changeThemeConnector(this.connectorTheme._id, false);
                } else if (type === "createColorList") {
                    const colorId = this.colorThemes.find((item) => item.localName(this.lang) === this.themeColorName)._id;
                    view.changeThemeColor(colorId);
                } else if (type === "editColorList") {
                    view.changeThemeColor(this.colorTheme._id);
                } else if (type === "createEffect") {
                    const effectId = this.effectThemes.find((item) => item.localName(this.lang) === this.themeEffectName)._id;
                    view.changeThemeEffect(effectId);

                    let _payload = {
                        clrThemeID: this.theme._clrThemeID || this.theme.clrThemeID,
                        cntThemeID: this.theme._cntThemeID || this.theme.cntThemeID,
                        effThemeID: effectId,
                        textThemeID: this.theme._textThemeID || this.theme.textThemeID,
                    };
                    view.createTheme(this.themeName, _payload, currentThemeId);

                    let changeTheme = this.themes.find((item) => item.localName(this.lang) === this.themeName);
                    let changeThemeId = changeTheme._id;
                    view.changeTheme(changeThemeId);
                    this.themeIsCustom = true;
                    this.oldThemeName = this.themeName;
                    this.$bus.$emit("setRightViewTitle", "editCustomTitle");
                } else if (type === "editEffect") {
                    view.changeThemeEffect(this.effectTheme._id);

                    let changeTheme = this.themes.find((item) => item.localName(this.lang) === this.themeName);
                    let changeThemeId = changeTheme ? changeTheme._id : this.theme._id || this.theme.themeID;
                    view.changeTheme(changeThemeId);
                }
            } else if (flag == false) {
                this.showMessage({
                    type: 2,
                    content: msgExist,
                });
            } else console.log("error");
            this.$bus.$emit("refreshTheme");
        }

        formatName(themeArr, myThemeText) {
            let themeName = "";
            const customList = themeArr.filter((temp) => temp.isCustom());
            const csutomNames = customList.map((item) => {
                return item.localName(this.lang);
            });
            const myThemeStr = myThemeText;
            const regex = this.buildRegex(myThemeStr);

            const mineThemeNames = csutomNames.filter((item) => {
                return regex.test(item);
            });
            if (mineThemeNames.length === 0 || (mineThemeNames.length === 1 && mineThemeNames[0] === myThemeStr)) {
                themeName = myThemeText + (mineThemeNames.length > 0 ? `(${mineThemeNames.length})` : "");
            } else {
                let maxNumber = -1;
                csutomNames.forEach((str) => {
                    const match = str.match(/\((\d+)\)/);
                    if (match && match[1]) {
                        const number = parseInt(match[1], 10);
                        // 检查是否是有效的数字，并更新最大值
                        if (!isNaN(number) && number > maxNumber) {
                            maxNumber = number;
                        }
                    }
                });
                themeName = myThemeText + `(${maxNumber + 1})`;
            }
            return themeName;
        }

        get connectorTheme() {
            return this.$store.getters.connectorTheme;
        }
        get connectorThemes() {
            return this.$store.getters.connectorThemes._themeCnts;
        }

        // oldLineId = 0;
        oldConnectorColor = null;
        initConnector(connectorTheme) {
            const { _width, _round, _dash, _startArrowID, _endArrowID, _startSize, _endSize, _color, _flowThemeColor } = this.parseQueryString(
                connectorTheme.getLineEditInfo()
            );
            this.strokeWidth = Number(_width) || 0.75;
            this.round = Number(_round);
            this.strokeStyle = Number(_dash) || 1;
            this.arrowStyleBegin = Number(_startArrowID);
            this.arrowStyleEnd = Number(_endArrowID);
            this.arrowSizeBegin = Number(_startSize);
            this.arrowSizeEnd = Number(_endSize);
            this.connectorColor = _color;
            this.oldConnectorColor = _color;
            this.connectorFlowThemeColor = !_flowThemeColor;
        }

        changeCurrentThemeConnector() {
            this.$nextTick(() => {
                const recommendConnector = this.connectorThemes.filter((item) => !item.isCustom());
                let recommendConnectorIds = recommendConnector.map((item) => item._id);
                this.changeCurrentTheme(recommendConnectorIds.indexOf(this.connectorTheme._id) > -1 ? "createConnector" : "editConnector");
            });
        }

        clickSelector(type: string, i: number) {
            if (type == "strokeStyle") this.strokeStyle = i;
            else if (type == "beginStyle") this.arrowStyleBegin = i;
            else if (type == "endStyle") this.arrowStyleEnd = i;
            else if (type == "beginSize") this.arrowSizeBegin = i;
            else if (type == "endSize") this.arrowSizeEnd = i;
            this.showSelector("");
            this.changeCurrentThemeConnector();
        }

        showConnectorColor = false;
        connectorFlowThemeColor = true;
        connectorColor = "#000000";
        changeLineFlowThemeColor(val) {
            if (val) {
                this.changeCurrentThemeConnector();
            }
        }

        changeThemeLineColor(color) {
            this.connectorColor = color;
            this.changeCurrentThemeConnector();
        }

        // colorList = []
        tempColorList = [];
        initColor(colorList) {
            this.colorList = colorList;
            if (!this.vip) {
                this.tempColorList = JSON.parse(JSON.stringify(this.colorList));
            }
        }

        currentColorIndex = -1;
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get colorList() {
            return this.$store.state.ui.themeColorList;
        }

        set colorList(v) {
            this.$store.commit("setStatus", {
                type: "themeColorList",
                data: v,
            });
        }

        showMoreColor(e, i, color) {
            let node = e.target;
            this.currentColorIndex = i;
            let payload = {
                type: this.fmtType.themeColor,
                index: i,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", {
                    e,
                    type: "123456",
                    newTopLeft: {
                        top: 5,
                        left: -5,
                    },
                });
            });
        }
        changeCurrnetThemeColor() {
            const recommendColor = this.colorThemes.filter((item) => !item.isCustom());
            let recoomendColorIds = recommendColor.map((item) => item._id);
            this.changeCurrentTheme(recoomendColorIds.indexOf(this.colorTheme._id) > -1 ? "createColorList" : "editColorList");
        }

        checkLimitColor() {
            // true 未更改颜色
            if (this.tempColorList.length > 0) {
                if (this.colorList.length != this.tempColorList.length) return false;
                for (let i = 0; i < this.colorList.length; i++) {
                    if (this.colorList[i] != this.tempColorList[i]) {
                        return false;
                    }
                }
                return true;
            }
            return false;
        }

        get colorThemes() {
            return this.$store.getters.colorThemes._themeColors;
        }

        backTheme() {
            this.resetTheme();
            this.$bus.$emit("itemChosen", "themeP", "other");
        }

        calcClrs(_colors) {
            let clrs: Array<string> = [];
            for (let i = 0; i < 18; ++i) {
                let color = "";
                if (i + 2 >= 0 && i + 2 < 18 && 0 >= 0) {
                    color = i + 2 >= 0 && i + 2 < 18 && 0 >= 0 ? _colors[i + 2][0] : "#ffffff";
                }
                clrs.push(color);
            }
            this.colorList = clrs;
            return clrs;
        }

        resetTheme() {
            const view = window["_view"];
            if (view) {
                if (!this.themeIsCustom) {
                    this.$bus.$emit("changeCurrentThemeTab", "recommend");
                    if (this.oldTheme.theme._id) {
                        view.changeTheme(this.oldTheme.theme._id);
                    } else if (this.oldTheme.theme.themeID === 0) {
                        this.resetOldTheme();
                    }
                } else {
                    this.$bus.$emit("changeCurrentThemeTab", "mine");
                    this.resetOldTheme();

                    let changeTheme = this.themes.find((item) => item.localName(this.lang) === this.themeName);
                    let changeThemeId = changeTheme._id;
                    view.changeTheme(changeThemeId);
                }
            }
        }

        resetOldTheme() {
            const { textTheme, colorTheme, connectorTheme } = this.oldTheme;
            this.initText(textTheme);
            this.initConnector(connectorTheme);
            this.colorList = this.calcClrs(colorTheme._colors);
            this.initColor(this.colorList);
            this.changeCurrentTheme("editText");
            this.changeCurrentTheme("editConnector");
            this.changeCurrentTheme("editColorList");
        }

        handleBeforeUnload(event) {
            this.resetTheme();
            const confirmationMessage = "Are you sure?";
            (event || window.event).returnValue = confirmationMessage; // 兼容旧版浏览器
            return confirmationMessage; // 兼容现代浏览器
        }

        showTextColor = false;
        textFlowThemeColor = true;

        get effectTheme() {
            return this.$store.getters.effectTheme;
        }

        get effectThemes() {
            return this.$store.getters.effectThemes._themeEffs;
        }

        fontColor = "#000000";
        oldEffectId = 0;
        initEffect() {
            this.textFlowThemeColor = !this.effectTheme.isCustom();
            if (!this.effectTheme.isCustom()) {
                this.oldEffectId = this.effectTheme._id;
            } else {
                this.oldEffectId = this.effectTheme._oldEffectId;
            }
            let effectInfo = this.parseQueryString(this.effectTheme.getEffectEditInfo());
            const { _color } = effectInfo;
            this.fontColor = _color;
        }

        changeTextFlowThemeColor(val) {
            if (val) {
                window["_view"].changeThemeEffect(this.oldEffectId);
            }
        }

        showBeginType: boolean = false;
        closeBeginTypes() {
            this.showBeginType = false;
        }

        toggleType(e: MouseEvent, type: string) {
            this["show" + type + "Type"] = !this["show" + type + "Type"];
            window["_view"]._tool.endEdit();
            if (type === "Begin" || type === "End") {
                if (this["show" + type + "Type"]) {
                    let target = e.target as HTMLElement;
                    let maxH = window.innerHeight - e.pageY - (target.clientHeight - e.offsetY) - this.$store.state.ui.sceneBottom - 32;

                    this.$nextTick(() => {
                        let downs = this.$refs[`${type}Ref`] as HTMLElement;
                        downs.style.maxHeight = (maxH <= 60 ? 60 : maxH) + "px";
                        let curSlider = this.$refs[`${type}Slider`] as any;
                        curSlider.$refs?.minTooltip?.updatePopper();
                    });
                }
            }
        }

        switchArrow() {
            let a = this.arrowSizeBegin,
                b = this.arrowSizeEnd,
                c = this.arrowStyleBegin,
                d = this.arrowStyleEnd;
            this.arrowSizeEnd = a;
            this.arrowSizeBegin = b;
            this.arrowStyleBegin = d;
            this.arrowStyleEnd = c;
            this.changeCurrentThemeConnector();
        }

        showEndType: boolean = false;
        closeEndTypes() {
            this.showEndType = false;
        }

        //生命周期
        mounted() {
            if (this.lang == "zh") {
                this.familyList = this.zhFamily.concat(this.enFamily);
            } else {
                this.familyList = this.enFamily.concat(this.zhFamily);
            }
            this.$bus.$on("rightPanelBackTheme", this.backTheme);
        }

        created() {}
        beforeDestroy() {
            // this.$bus.$off("themeColorListChanged");
            this.$bus.$off("rightPanelBackTheme");
            // window.removeEventListener('beforeunload', this.handleBeforeUnload);
        }
        activated() {
            this.initCurTheme();
            this.$bus.$emit(
                "setRightViewTitle",
                this.themeIsCustom || !this.theme || (this.theme && this.theme.themeID === 0) ? "editCustomTitle" : "editTheme"
            );
            this.$bus.$on("themeColorListChanged", this.changeCurrnetThemeColor);
            this.$bus.$on("changeThemeFontColor", (color) => this.changeThemeTextColor(color));
            this.$bus.$on("changeThemeLineColor", (color) => this.changeThemeLineColor(color));
            this.initText(this.textTheme);
            this.initConnector(this.connectorTheme);
            this.initColor(window["_view"].getDisplayColor(this.theme.clrThemeID || this.theme._clrThemeID));
            this.initEffect();
            window.addEventListener("beforeunload", this.handleBeforeUnload);
        }
        deactivated() {
            this.$bus.$off("themeColorListChanged");
            window.removeEventListener("beforeunload", this.handleBeforeUnload);
        }
    }
</script>
<i18n>
{
  "zh": {
    "editBoxTitle": "自定义主题",
    "myTheme": "我的主题",
    "bold": "加粗 Ctrl+B",
    "italy": "斜体 Ctrl+I",
    "underline": "下划线 Ctrl+U",
    "Very Small": "非常小",
    "Small": "小",
    "Middle": "中",
    "Large": "大",
    "Extra Large": "特大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "existTheme": "该主题名已存在，请重新输入",
    "saveSuccess": "保存成功",
    "noName": "请输入主题名",
    "noColorName": "请输入颜色名",
    "noLineName": "请输入连接线名",
    "noTextName": "请输入文本名",
    "existTheme": "该主题名已存在，请重新输入",
    "myText": "我的文本",
    "myStyle": "我的样式",
    "myColor": "我的配色",
    "myEffect": "我的效果",
    "editCustomTitle": "编辑主题",
    "arrowSize": "箭头大小",
    "beginType": "起点",
    "beginSize": "起点大小",
    "endType": "终点",
    "endSize": "终点大小",
    "text": "文本",
    "textColor": "文本颜色",
    "followThemeColor": "跟随主题颜色",
    "colors": "配色",
    "line": "连接线",
    "thickness": "粗细",
    "cornerRadius": "圆角",
    "lineStyle": "线条样式",
    "save": "保存",
    "saveAsMyTheme": "另存为我的主题",
    "lineColor": "线条颜色"
  },
  "en": {
    "editBoxTitle": "Custom Theme",
    "myTheme": "My Themes",
    "bold": "Bold Ctrl+B",
    "italy": "Italic Ctrl+I",
    "underline": "Underline Ctrl+U",
    "Very Small": "Very Small",
    "Small": "Small",
    "Middle": "Middle",
    "Large": "Large",
    "Extra Large": "Extra Large",
    "Jumbo": "Jumbo",
    "Colossal": "Colossal",
    "existTheme": "The theme name already exists，please retry.",
    "noName": "Enter Theme Name",
    "noColorName": "Please enter the color name.",
    "noLineName": "Please enter the connecting line name.",
    "noTextName": "Please enter the text name.",
    "existTheme": "The theme name already exists，please retry.",
    "myText": "My Text",
    "myStyle": "My Styles",
    "myColor": "My Colors",
    "myEffect": "My Effect",
    "editCustomTitle": "Edit",

    "arrowSize": "Arrow size",
    "beginType": "Begin type",
    "beginSize": "Begin size",
    "endType": "End type",
    "endSize": "End size",
    "text": "Text",
    "textColor": "Text Color",
    "followThemeColor": "Follow Theme Color",
    "colors": "Colors",
    "line": "Connector",
    "thickness": "Thickness",
    "cornerRadius": "Corner Radius",
    "lineStyle": "Line Style",
    "save": "Save",
    "saveAsMyTheme": "Save as My Theme",
    "lineColor": "Line Color"
  },
  "fr": {
     "editBoxTitle": "Thème personnalisé",
     "myTheme": "Mes thèmes",
     "bold": "Audacieux",
    "italy": "Italique",
    "underline": "Souligner",
    "Very Small": "Très Petit",
    "Small": "Petit",
    "Middle": "Moyen",
    "Large": "Grand",
    "Extra Large": "Très Grand",
    "Jumbo": "Géant",
    "Colossal": "Colossal",
    "existTheme": "Le nom du thème existe déjà, veuillez ressaisir",
    "saveSuccess": "Enregistré avec succès",
    "noName": "Veuillez Entrer un Nom de Sujet",
    "noColorName": "Veuillez Entrer un Nom de Couleur",
    "noLineName": "Veuillez Entrer un Nom de Connecteur",
    "noTextName": "Veuillez Entrer un nom de texte",
    "existTheme": "Le nom du thème existe déjà, veuillez ressaisir",
    "myText": "Mes texte",
    "myStyle": "Mes styles",
    "myColor": "Mes couleurs",
    "myEffect": "My Effect",
    "editCustomTitle": "Modifier",
    "arrowSize": "Taille de la flèche",
    "beginType": "Type de début",
    "beginSize": "Taille de début",
    "endType": "Type de fin",
    "endSize": "Taille de fin",
    "text": "Texte",
    "textColor": "Couleur du texte",
    "followThemeColor": "Suivre la couleur du thème",
    "colors": "Couleurs",
    "line": "Ligne de connexion",
    "thickness": "Épaisseur",
    "cornerRadius": "Rayon de l'angle",
    "lineStyle": "Style de trait",
    "save": "Enregistrer",
    "saveAsMyTheme": "Enregistrer comme Mon thème",
    "lineColor": "Couleur du trait"
  },
  "de": {
     "editBoxTitle": "Benutzerdefiniertes Design",
     "myTheme": "Meine Designs",
     "bold": "Fett Ctrl+B",
    "italy": "Kursiv Ctrl+I",
    "underline": "Unterstreichen Ctrl+U",
    "Very Small": "Sehr klein",
    "Small": "Klein",
    "Middle": "Mittel",
    "Large": "Groß",
    "Extra Large": "sehr Groß",
    "Jumbo": "Rießig",
    "Colossal": "Übergroß",
    "existTheme": "Der Themenname existiert bereits. Bitte versuchen Sie es erneut",
    "saveSuccess": "Erfolgreich gespeichert",
    "noName": "Themenname eingeben",
    "noColorName": "Bitte den Farbnamen eingeben",
    "noLineName": "Bitte den Verbindungsliniennamen eingeben",
    "noTextName": "Bitte den Textnamen eingeben",
    "existTheme": "Der Themenname existiert bereits. Bitte versuchen Sie es erneut",
    "myText": "Meine Text",
    "myStyle": "Meine Stile",
    "myColor": "Meine Farben",
    "myEffect": "Meine Effect",
    "editCustomTitle": "Bearbeiten",
    "arrowSize": "Pfeilgröße",
    "beginType": "Anfangsformat",
    "beginSize": "Anfangsgröße",
    "endType": "Endformat",
    "endSize": "Endgröße",
    "text": "Text",
    "textColor": "Textfarbe",
    "followThemeColor": "Farbdesign folgen",
    "colors": "Farben",
    "line": "Verbinder",
    "thickness": "Dicke",
    "cornerRadius": "Eckradius",
    "lineStyle": "Linienart",
    "save": "speichern",
    "saveAsMyTheme": "Als mein Design speichern",
    "lineColor": "Liniensfarbe"
  },
  "jp": {
     "editBoxTitle": "カスタムテーマ",
     "myTheme": "マイテーマ",
     "bold": "太字",
    "italy": "斜体",
    "underline": "下線",
    "Very Small": "小さな",
    "Small": "小さい",
    "Middle": "真ん中",
    "Large": "大きい",
    "Extra Large": "特大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "existTheme": "テーマ名は既に存在します。再入力してください。",
    "saveSuccess": "正常に保存されました",
    "noName": "テーマ名を入力してください",
    "noColorName": "色の名前を入力してください",
    "noLineName": "接続線の名前を入力してください",
    "noTextName": "テキストの名前を入力してください",
    "existTheme": "テーマ名は既に存在します。再入力してください。",
    "myText": "私のテキストです",
    "myStyle": "マイスタイル",
    "myColor": "マイカラー",
    "myEffect": "マイエフェクト",
    "editCustomTitle": "編集",
    "arrowSize": "矢印サイズ",
    "beginType": "始点",
    "beginSize": "始点のサイズ",
    "endType": "終点",
    "endSize": "終点のサイズ",
    "text": "テキスト",
    "textColor": "テキストの色",
    "followThemeColor": "テーマの色に従う",
    "colors": "色",
    "line": "コネクター",
    "thickness": "太さ",
    "cornerRadius": "角の半径",
    "lineStyle": "線の形式",
    "save": "保存",
    "saveAsMyTheme": "マイテーマとして保存",
    "lineColor": "線の色"
  },
  "es": {
     "editBoxTitle": "Tema personalizado",
     "myTheme": "Mis temas",
     "bold": "Negrita Ctrl+B",
    "italy": "Cursiva Ctrl+I",
    "underline": "Subraye Ctrl+U",
    "Very Small": "Muy pequeño",
    "Small": "Pequeño",
    "Middle": "Medio",
    "Large": "Grande",
    "Extra Large": "Extra grande",
    "Jumbo": "Jumbo",
    "Colossal": "Colosal",
    "existTheme": "El nombre del tema ya existe，por favor, reintentar",
    "saveSuccess": "Guardar con éxito.",
    "noName": "Introduzca el nombre del tema",
    "noColorName": "Por favor, introduzca el nombre del color",
    "noLineName": "Por favor, introduzca el nombre de la línea de conexión",
    "noTextName": "Por favor, introduzca el nombre de texto",
    "existTheme": "El nombre del tema ya existe，por favor, reintentar",
    "myText": "Mis texto",
    "myStyle": "Mis estilos",
    "myColor": "Mis colores",
    "myEffect": "Mis Effect",
    "editCustomTitle": "Editar",
    "arrowSize": "Tamaño de flecha",
    "beginType": "Empezar a escribir",
    "beginSize": "Comenzar el tamaño",
    "endType": "Tipo de final",
    "endSize": "Tamaño final",
    "text": "Texto",
    "textColor": "Color del texto",
    "followThemeColor": "Seguir color del tema",
    "colors": "Colores",
    "line": "Conector",
    "thickness": "Grosor",
    "cornerRadius": "Radio de redondeo",
    "lineStyle": "Estilo de línea",
    "save": "Guardar",
    "saveAsMyTheme": "Guardar como Mi tema",
    "lineColor": "Color de línea"
  },
  "pt": {
     "editBoxTitle": "Tema personalizado",
     "myTheme": "Meus temas",
     "bold": "Negrito Ctrl+B",
    "italy": "Itálico Ctrl+I",
    "underline": "Sublinhar Ctrl+U",
    "Very Small": "Muito Pequeno",
    "Small": "Pequeno",
    "Middle": "Médio",
    "Large": "Grande",
    "Extra Large": "Muito Grande",
    "Jumbo": "Enorme",
    "Colossal": "Colossal",
    "existTheme": "O nome do tema já existe, por favor, repetir.",
    "saveSuccess": "Gravado com Sucesso.",
    "noName": "Inserir Nome do Tema",
    "noColorName": "Por favor, inserir o nome da cor.",
    "noLineName": "Por favor, inserir o nome da linha de conexão.",
    "noTextName": "Por favor, inserir o nome do texto.",
    "existTheme": "O nome do tema já existe, por favor, repetir.",
    "myText": "Meus texto",
    "myStyle": "Meus estilos",
    "myColor": "Minhas cores",
    "myEffect": "Minhas Effect",
    "editCustomTitle": "Editar",
    "arrowSize": "Arrow size",
    "beginType": "Tipo de Início",
    "beginSize": "Tamanho de Início",
    "endType": "Tipo de Fim",
    "endSize": "Tamanho de Fim",
    "text": "Texto",
    "textColor": "Cor do Texto",
    "followThemeColor": "Seguir cor do tema",
    "colors": "Cores",
    "line": "Conector",
    "thickness": "Espessura",
    "cornerRadius": "Raio de canto",
    "lineStyle": "Estilo de linha",
    "save": "Salvar",
    "saveAsMyTheme": "Salvar como Meu tema",
    "lineColor": "Cor da Linha"
  },
  "it": {
     "editBoxTitle": "Tema personalizzato ",
     "myTheme": "I miei temi",
     "bold": "Grassetto Ctrl+B",
    "italy": "Italico Ctrl+I",
    "underline": "Sottolineato Ctrl+U",
    "Very Small": "Molto Piccolo",
    "Small": "Piccolo",
    "Middle": "Medio",
    "Large": "Grande",
    "Extra Large": "Molto Grande",
    "Jumbo": "Enorme",
    "Colossal": "Colossale",
    "existTheme": "Esiste già un tema con questo nome. Si prega di sceglierne un altro.",
    "saveSuccess": "Salvataggio avvenuto con successo.",
    "noName": "Immettere il nome del tema",
    "noColorName": "Immettere il nome del colore.",
    "noLineName": "Immettere il nome della linea di connessione.",
    "noTextName": "Immettere il nome del testo.",
    "existTheme": "Esiste già un tema con questo nome. Si prega di sceglierne un altro.",
    "myText": "I miei testo",
    "myStyle": "I miei stili",
    "myColor": "I miei colori",
    "myEffect": "I miei Effect",
    "editCustomTitle": "Modifica",
    "arrowSize": "Dimensione freccia",
    "beginType": "Tipo Parte Iniziale",
    "beginSize": "Dimensione Parte Iniziale",
    "endType": "Tipo Parte Finale",
    "endSize": "Dimensione Parte Finale",
    "text": "Testo",
    "textColor": "Colore testo",
    "followThemeColor": "Segui colore tema",
    "colors": "Colori",
    "line": "Connettore",
    "thickness": "Spessore",
    "cornerRadius": "Raggio angolo",
    "lineStyle": "Stile linea",
    "save": "Salva",
    "saveAsMyTheme": "Salva come Il mio tema",
    "lineColor": "Colore linea"
  },
  "tw": {
    "editBoxTitle": "自定义主题",
    "myTheme": "My Themes",
    "bold": "加粗 Ctrl+B",
    "italy": "斜體 Ctrl+I",
    "underline": "下劃線 Ctrl+U",
    "Very Small": "非常小",
    "Small": "小",
    "Middle": "中",
    "Large": "大",
    "Extra Large": "特大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "existTheme": "該主題名已存在，請重新輸入",
    "saveSuccess": "儲存成功",
    "noName": "請輸入主題名",
    "noColorName": "請輸入顏色名",
    "noLineName": "請輸入連接線名",
    "noTextName": "請輸入文本名",
    "existTheme": "該主題名已存在，請重新輸入",
    "myText": "My Text",
    "myStyle": "My Styles",
    "myColor": "My Colors",
    "myEffect": "我的效果",
    "editCustomTitle": "编辑主题"
  }
}
</i18n>
